
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import LocationForm from '../components/forms/LocationForm';
import '../styles/EmployeeMaster.css';
import LocationTable from '../components/LocationTable';

const LocationModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/location/add';

  const handleAddClick = () => {
    navigate('/location/add');
  };

  const handleCloseModal = () => {
    navigate('/location');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Location Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Location
        </button>
      </div>

      <LocationTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LocationForm />
        </Modal.Body>
        
      </Modal>
    </div>
  );
};

export default LocationModel;
